import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom'
import { AuthProvider } from './context/AuthContext'
import { LoginPageCustom } from './pages/Login'
import { HomePage } from './pages/Home'
import { ProfilePage } from './pages/Profile'
import FreeSubscription from './pages/FreeSubscription'
import { useAuth } from './context/AuthContext'
import { Toaster } from 'react-hot-toast'
import ErrorBoundary from './components/ErrorBoundary'
import { NotionStatusPage } from './pages/notion/NotionStatusPage'
import ForceGraphPage from './pages/ForceGraph'
import WrappedPage from './pages/Wrapped.tsx'
import { PostDetailPage } from './pages/PostDetail'
import { CheckoutPage } from './pages/Checkout'
import { McpAuthorizePage } from './pages/McpAuthorize'
import DowntimeBanner from './components/DowntimeBanner'
import { useState } from 'react'

const ProtectedRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated } = useAuth()
  const location = useLocation()
  
  if (!isAuthenticated) {
    const redirectPath = location.pathname + location.search;
    const loginUrl = `/login?redirect=${encodeURIComponent(redirectPath)}`;
    return <Navigate to={loginUrl} state={{ from: location }} replace />
  }
  
  return children;
}

function App() {
  const [bannerVisible, setBannerVisible] = useState(false);

  return (
    <ErrorBoundary>
      <DowntimeBanner onVisibilityChange={setBannerVisible} />
      <div className={bannerVisible ? 'pt-10' : ''}>
      <BrowserRouter>
        <AuthProvider>
          <Toaster position="top-right" toastOptions={{ duration: 4000 }} />
          <Routes>
            <Route path="/login" element={<LoginPageCustom />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <HomePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/post/detail/:id"
              element={
                <ProtectedRoute>
                  <PostDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/profile"
              element={
                <ProtectedRoute>
                  <ProfilePage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/free-subscription"
              element={
                <ProtectedRoute>
                  <FreeSubscription />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notion/status"
              element={
                <ProtectedRoute>
                  <NotionStatusPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/3d-visualisation"
              element={
                <ProtectedRoute>
                  <ForceGraphPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/rewind25"
              element={
                <ProtectedRoute>
                  <WrappedPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/checkout"
              element={
                <ProtectedRoute>
                  <CheckoutPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/mcp/authorize"
              element={
                <ProtectedRoute>
                  <McpAuthorizePage />
                </ProtectedRoute>
              }
            />
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </AuthProvider>
      </BrowserRouter>
      </div>
    </ErrorBoundary>
  )
}

export default App